import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';

import { constants } from '../../../config';
import { routeNaming, goToPage } from '../../../routes';
import { SecondaryButton } from '../../../common/secondary-button';
import { LoginHelper } from '../../../helpers/LoginHelper';
import { getDebitCartTax } from '../../../helpers/CartHelper';
import { CartStore } from '../../../stores/CartStore';
import { CHECKOUT_STAGES } from '../../../stores/CheckoutStore';
import { SessionStore } from '../../../stores/SessionStore';
import { ScreenStore } from '../../../stores/ScreenStore';
import { ConfigParametersStore } from '../../../stores/ConfigParametersStore';
import styles from './Summary.css';
import * as modalGlobal from '../../../common/global/modal';

const IPropTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: '',
};

const onContinueClick = () => {
  if (ConfigParametersStore.parameters.disableSale &&
    ConfigParametersStore.parameters.disableSale.status) {
    modalGlobal.showModal(
      '', <p>{ConfigParametersStore.parameters.disableSale.message}</p>, false, null,
      null, false, null,
      'Cerrar', true, null,
    );
    return;
  }
  if (!SessionStore.loggedIn) {
    // Force the user to login
    LoginHelper.setLoginSuccessRoute(routeNaming.CART);
    goToPage(routeNaming.LOGIN);
  } else {
    goToPage(routeNaming.CHECKOUT, { checkoutStep: CHECKOUT_STAGES.CHOOSE_ADDRESS });
  }
};

const Summary = (props) => {
  const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
  return (
    <div className={[props.className, styles.container].join(' ')}>
      {
        !mobileVersion &&
        <h4 className={styles.title}>
          Resumen
        </h4>
      }
      <div className={styles.totalsContainer}>
        <p className={styles.subtotal}>
          Subtotal ({CartStore.cartTotalItems} producto{CartStore.cartTotalItems !== 1 && 's'})
        </p>
        <p className={styles.price}>
          ${CartStore.cart ? CartStore.cartTotalPriceWithoutDebitCardTaxString : 0}
        </p>
      </div>
      {
        !mobileVersion &&
        <div className={styles.separator} />
      }
      {/* TODO: implement this action */}
      <SecondaryButton
        className={styles.continueButton}
        disabled={
          !CartStore.cart ||
          !CartStore.cart.length ||
          !CartStore.cartStatusIsValid ||
          getDebitCartTax(CartStore.cart) != null
        }
        onClick={onContinueClick}
      >
        Continuar
      </SecondaryButton>
    </div>
  );
};

Summary.propTypes = IPropTypes;
Summary.defaultProps = defaultProps;

const ObservedSummary = observer(Summary);

export { ObservedSummary as Summary };



// WEBPACK FOOTER //
// ./src/pages/cart/summary/Summary.jsx